<template>
  <!-- 增加修改 -->
  <a-drawer
    :maskClosable="false"
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="手机号" prop="phoneNumber">
        <div @click="handleInputClick" class="input-wrapper">
          <a-input v-model="form.phoneNumber" placeholder="请输入" :maxLength="11" :disabled="flage" />
        </div>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ !isFage ? '保存' : '绑定' }}
          </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { getUser, addUser, updateUser, deptTreeSelect, checkPhone, userBd } from '@/api/system/user'
import { pageRole } from '@/api/system/role'
import { regionList } from '@/api/pressure/region'
export default {
  name: 'CreateForm',
  dicts: ['sys_enable_disable'],
  data() {
    const regPass = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$/
    const validatePass = (rule, value, callback) => {
      console.log(value, 'valuevalue')
      if (!value) {
        callback()
      } else if (!regPass.test(value)) {
        callback(new Error('请输入密码6-12位(数字+字母)'))
      } else {
        callback()
      }
    }
    return {
      submitLoading: false,
      isShow: false,
      flage: true,
      clickTimer: null,
      clickCount: 0, // 点击计数器
      deptOption: [
        {
          id: 0,
          label: '',
          children: [],
        },
      ],
      userId: '',
      replaceFields: { children: 'children', title: 'label', key: 'id', value: 'id' },
      // 岗位选项
      postOptions: [],
      // 角色选项
      roleOptions: [],
      // 默认密码
      initPassword: undefined,
      formTitle: '',
      rolesId: [],
      isFage: false,
      isEdit: false,
      // 表单参数
      form: {
        id: undefined,
        deptId: 0,
        userName: undefined,
        nickName: undefined,
        password: undefined,
        phoneNumber: undefined,
        email: undefined,
        sex: 0,
        status: 1,
        remark: undefined,
        postIds: [],
        roleIds: [],
        cardImgs: [],
        avatar: undefined,
        birthday: undefined,
      },
      open: false,
      showLoading: false,
      // userRegion: [],
      rules: {
        roleIds: [{ required: true, message: '请选择角色', trigger: 'blur' }],
        // regionId: [{ required: true, message: '请选择区域', trigger: 'blur' }],
        userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        nickName: [{ required: true, message: '请输入用户姓名', trigger: 'blur' }],
        // deptId: [{ required: true, message: '部门不能为空', trigger: 'change' }],
        password: [
          // { required: true, message: '密码不能为空', trigger: 'blur' },
          { validator: validatePass, trigger: 'change' },
        ],
        // email: [
        //   { required: true, message: '邮箱不能为空', trigger: 'blur' },
        //   {
        //     type: 'email',
        //     message: '请正确填写邮箱地址',
        //     trigger: ['blur', 'change'],
        //   },
        // ],
        phoneNumber: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: '请正确填写手机号',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  filters: {},
  created() {
    // this.deptOption = this.deptOptions
    console.log(this.deptOptions, 'this.deptOptions')
    console.log(this.infoUser, 'infoUser')
    if (this.role) {
      pageRole({ roleKey: this.role }).then((res) => {
        console.log(res, '测试角色细心')
        if (res.data.records.length) {
          this.rolesId = [res.data.records[0].id]
        }
      })
    }
    console.log(this.role, '测试角色====')
    // if (this.userType === 1 || this.userType === 0) {
    //   this.getQu()
    // }
  },
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
  },
  watch: {},
  methods: {
    handleInputClick() {
      // 只有当前处于禁用状态时才计数
      if (this.flage) {
        this.clickCount++
        // 第一次点击时设置定时器，1秒后重置计数
        if (this.clickCount === 1) {
          this.clickTimer = setTimeout(() => {
            this.clickCount = 0 // 1秒后未完成3次点击，重置计数
          }, 1000)
        }
        // 达到3次点击且在1秒内
        else if (this.clickCount >= 3) {
          clearTimeout(this.clickTimer) // 清除定时器
          this.flage = false // 启用输入框
          this.clickCount = 0 // 重置计数
        }
      }
    },
    onClose() {
      const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          that.open = false
        },
        onCancel() {},
      })
    },
    // 查询区域
    getQu() {
      regionList().then((res) => {
        console.log(res, '的点点滴滴')
        this.userRegion = res.data
      })
    },
    // 点击角色发生变化
    handleRoleChange(e) {},
    // 点击添加区域
    handleQu() {
      this.childrenDrawer = true
      this.$nextTick(() => {
        this.$refs.ReginForm.handleAdd()
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    /** 查询部门下拉树结构 */
    getDeptTree() {
      deptTreeSelect().then((response) => {
        this.deptOptions = response.data
      })
    },
    /** 上传图片成功回调 */
    getImg(info, fieldName) {
      this.form[fieldName] = info
      this.$refs.form.clearValidate(fieldName)
    },
    // 取消按钮
    cancel() {
      this.onClose()
    },
    // 表单重置
    reset() {
      this.flage = true
      this.form = {
        id: undefined,
        deptId: undefined,
        userName: undefined,
        nickName: undefined,
        password: undefined,
        phoneNumber: undefined,
        email: undefined,
        sex: 0,
        status: 1,
        remark: undefined,
        postIds: [],
        roleIds: [],
        cardImgs: [],
        avatar: undefined,
        birthday: undefined,
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.isEdit = false
      this.reset()
      this.$emit('select-tree')
      this.open = true
      if (this.role == 'YSY00') {
        this.formTitle = '新增验收员'
      } else if (this.role == 'SG00') {
        this.formTitle = '新增水工'
      } else {
        this.formTitle = '新增用户'
      }
      this.form.password = this.initPassword
      this.isFage = false
      this.isShow = false
      this.getuserInfo()
    },
    // 查询用户信息
    getuserInfo() {
      getUser(this.userId ? this.userId : '').then((response) => {
        console.log(response, 'responseresponseresponse=======')
        this.postOptions = response.data.posts
        this.roleOptions = response.data.roles
      })
    },
    // 手机号发生变化
    handleChangePhone() {
      // if (!this.role) return
      const phoneNumber = this.form.phoneNumber
      const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
      if (phoneNumber && phoneNumber.length === 11) {
        if (!reg.test(phoneNumber)) return this.$message.error('请输入正确的手机号')
        checkPhone({ phoneNumber: this.form.phoneNumber }).then((res) => {
          console.log(res, '的点点滴滴')
          if (Number(res.data.unique) === 1) {
            const phone = this.form.phoneNumber
            this.form = res.data
            this.form.phoneNumber = phone
            this.isShow = true
            this.isFage = true
          } else {
            // this.get
            this.isShow = true
            this.isFage = false
            this.reset()
            this.form.phoneNumber = phoneNumber
            this.$forceUpdate()
          }
          //   if(res.unique==1){
          // 	this.show=false
          // 	this.id=res.id
          // }else{
          // 	this.show=true
          // }
        })
      }
    },
    // 选择生日
    handleChange(date, dateString) {
      console.log(date, dateString, '的点点滴滴')
      this.form.birthday = dateString
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.$emit('select-tree')
      const userId = row ? row.id : ids
      // this.formTitle = '修改用户'
      if (this.role == 'YSY00') {
        this.formTitle = '修改验收员'
      } else if (this.role == 'SG00') {
        this.formTitle = '修改水工'
      } else {
        this.formTitle = '修改用户'
      }
      this.isEdit = true
      this.isFage = false
      this.open = true
      this.userId = this.userId
      getUser(userId).then((response) => {
        console.log(response, 'responseresponseresponse')
        if (response.data.data.deptId == 0) {
          response.data.data.deptId = undefined
        }
        response.data.data.roleIds = response.data.roleIds
        response.data.data.postIds = response.data.postIds
        if (response.data.data.regionId == 0 || !response.data.data.regionId) {
          response.data.data.regionId = undefined
        }
        this.form = response.data.data
        console.log(this.form, '顶顶顶顶')

        this.postOptions = response.data.posts
        this.roleOptions = response.data.roles
        console.log(this.roleOptions, 'this.roleOptionsthis.roleOptions')
        // this.form.postIds = response.data.postIds
        // this.form.roleIds = response.data.roleIds
        this.open = true
        // this.formTitle = '修改用户'
        this.form.password = undefined
      })
      if (this.role) {
        // this.form
      }
      // this.isFage=true
      this.isShow = true
      // console.log(this.isShow,'this.isShow.isFage');
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.isFage, 'isFageisFage')
      const that = this
      this.$refs.form.validate((valid, object) => {
        console.log(object, 'objectobject')
        if (valid) {
          this.$confirm({
            title: '提示',
            content: '是否确认修改此账号数据?',
            onOk() {
              that.showLoading = true
              that.$nextTick(() => {
                that.$refs.LoadingPop.init(1)
              })
              return updateUser(that.form)
                .then((response) => {
                  that.$message.success('修改成功', 3)
                  that.open = false
                  that.$emit('ok')
                })
                .finally(() => {
                  that.submitLoading = false
                  that.showLoading = false
                })
            },
            onCancel() {},
          })
        } else {
          const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          console.log(messages, 'messages')
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(2, messages)
          })
          return false
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.form_select {
  display: flex;
  align-items: center;
  .ant-select {
    width: 300px;
    margin-right: 20px;
  }
}
.input-wrapper {
  display: inline-block;
  position: relative;
  width: 100%;
}

.input-wrapper::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1; /* 确保在输入框上方 */
  pointer-events: auto; /* 允许点击穿透到容器 */
}

/* 禁用状态的输入框可能需要调整样式 */
.a-input[disabled] {
  pointer-events: none; /* 确保输入框本身不响应点击 */
}
</style>
